import { createAction, props } from '@ngrx/store'
import { LastNMatchesResponse, Match, MatchTeam } from '@core/models/match.models'
import { MetricMap } from '@core/models/metric.models'
import { PassMatrix } from '@pages/match-detail/models/match-detail.models'
import { AggregationSelectable } from '@features/aggregations/models/aggregations.models'
import { Heatmap } from '@core/models/heatmap.models'
import { Asset } from '@core/models/assets.models'
import { MatchTab } from '@pages/matches/enums/matches.enum'
import { VideoType } from '@core/enums/video.enums'

export const fetchMatchData = createAction(
  '[Match Detail] fetch match data',
  props<{
    match: Match
    videoType: VideoType
  }>()
)

export const fetchMatch = createAction(
  '[Match Detail] fetch match',
  (matchId: string, videoType: VideoType = VideoType.Tactical) => ({
    matchId,
    videoType
  })
)

export const fetchOnlyMatch = createAction(
  '[Match Detail] fetch only match',
  (matchId: string, videoType: VideoType = VideoType.Tactical) => ({
    matchId,
    videoType
  })
)
export const setMatch = createAction('[Match Detail] set match', props<{ match: Match }>())

export const fetchMatchAssets = createAction('[Match Detail] fetch match assets', props<{ matchId: string }>())
export const setMatchAssets = createAction('[Match Detail] set match assets', props<{ assets: Asset[] }>())

export const fetchMatchLastMatchesTrend = createAction(
  '[Match Detail] fetch match last matches trend',
  props<{
    matchId: string
  }>()
)

export const setMatchLastMatchesTrend = createAction(
  '[Match Detail] set match last matches trend',
  props<{
    lastMatches: LastNMatchesResponse
  }>()
)

export const fetchMatchMetrics = createAction('[Match Detail] fetch match metrics', props<{ matchId: string }>())
export const setMatchMetrics = createAction('[Match Detail] set match metrics', props<{ metrics: MetricMap }>())

export const fetchMatchLineup = createAction('[Match Detail] fetch match lineup', props<{ match: Match }>())
export const setMatchLineup = createAction('[Match Detail] set match lineup', props<{ lineup: any }>())

export const fetchMatchHeatMap = createAction('[Match Detail] fetch match heatmap', props<{ match: Match }>())
export const setMatchHeatMap = createAction('[Match Detail] set match heatmap', props<{ heatMap: Heatmap }>())
export const setMatchHeatMapLoader = createAction(
  '[Match Detail] set match heatmap loader',
  props<{ heatMapLoading: boolean }>()
)

export const fetchMatchPassMatrix = createAction('[Match Detail] fetch match pass matrix', props<{ matchId: string }>())
export const setMatchPassMatrix = createAction(
  '[Match Detail] set match pass matrix',
  props<{ passMatrix: PassMatrix }>()
)
export const setMatchPassMatrixLoader = createAction(
  '[Match Detail] set match pass matrix loader',
  props<{ passMatrixLoading: boolean }>()
)

export const fetchMatchPreviousMetrics = createAction('[Match Detail] fetch match previous metrics')
export const setMatchPreviousMetrics = createAction(
  '[Match Detail] set match previous metrics',
  props<{ previousMetrics: MetricMap }>()
)

export const purgeMatchData = createAction('[Match Detail] purge match data')

export const setMatchLoader = createAction('[Match Detail] set match loader', props<{ matchLoading: boolean }>())
export const setMatchTrendLoader = createAction(
  '[Match Detail] set match trend loader',
  props<{ trendLoading: boolean }>()
)
export const setMatchMetricsLoader = createAction(
  '[Match Detail] set match metrics loader',
  props<{ metricsLoading: boolean }>()
)
export const setMatchPrevMetricsLoader = createAction(
  '[Match Detail] set match previous metrics loader',
  props<{ prevMetricLoading: boolean }>()
)
export const setMatchLineupLoader = createAction(
  '[Match Detail] set match lineup loader',
  props<{ lineupLoading: boolean }>()
)

export const setMatchTabs = createAction('[Match Detail] set match tabs', props<{ tabs: string[] }>())
export const setMatchActiveTabId = createAction(
  '[Match Detail] set match active tab id',
  props<{ activeTabId: MatchTab | string }>()
)

export const setMatchPreviousLeftAggregation = createAction(
  '[Match Detail] set match previous left aggregation',
  props<{ previousLeftAggregation: AggregationSelectable }>()
)
export const setMatchPreviousRightAggregation = createAction(
  '[Match Detail] set match previous right aggregation',
  props<{ previousRightAggregation: AggregationSelectable }>()
)

export const setMatchPreviousAggregations = createAction(
  '[Match Detail] set match previous aggregations',
  props<{ previousLeftAggregation: AggregationSelectable; previousRightAggregation: AggregationSelectable }>()
)

export const setMatchLineupAggregation = createAction(
  '[Match Detail] set match lineup aggregation',
  props<{ lineupAggregation: AggregationSelectable }>()
)

export const setMatchLeftTeam = createAction('[Match Detail] set match left team', props<{ leftTeam: MatchTeam }>())
export const setMatchRightTeam = createAction('[Match Detail] set match right team', props<{ rightTeam: MatchTeam }>())

export const setMatchPreviousLeftTeam = createAction(
  '[Match Detail] set match previous left team',
  props<{ previousLeftTeam: MatchTeam }>()
)
export const setMatchPreviousRightTeam = createAction(
  '[Match Detail] set match previous right team',
  props<{ previousRightTeam: MatchTeam }>()
)

export const updateMatchSelectedTeam = createAction(
  '[Match Detail] update match selected team',
  props<{ direction: 'left' | 'right' }>()
)

export const updateMatchSelectedPreviousTeam = createAction(
  '[Match Detail] update match selected previous team',
  props<{ direction: 'left' | 'right' }>()
)

export const updateMatchLineupAggregation = createAction(
  '[Match Detail] update match lineup aggregation',
  props<{ lineupAggregation: AggregationSelectable }>()
)
